// const baseurl = "http://103.186.185.77:5033/camarketing/adminportal/"
export const baseurl = "https://api.alludeapp.com/v1/alludeapi/admin/";
export const imgUrl = "https://api.alludeapp.com/";
